import { render, staticRenderFns } from "./NoticleArcKaiting.vue?vue&type=template&id=90542c52&scoped=true&"
import script from "./NoticleArcKaiting.vue?vue&type=script&lang=js&"
export * from "./NoticleArcKaiting.vue?vue&type=script&lang=js&"
import style0 from "./NoticleArcKaiting.vue?vue&type=style&index=0&id=90542c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90542c52",
  null
  
)

export default component.exports